<template>
  <main-drawer title="Izmeni udruženje" :size="500" @close="$emit('close')">
    <main-input v-model="form.name" :validator="$v.form.name" :label="$tc('club.club_name')" />
    <main-input v-model="form.shortName" :validator="$v.form.shortName" :label="$tc('club.short_name')" />
    <main-input v-model="form.city" :validator="$v.form.city" :label="$tc('form.city')" />
    <main-input v-model="form.address" :validator="$v.form.address" :label="$tc('form.address')" />
    <main-input v-model="form.email" :validator="$v.form.email" :label="$tc('form.email')" />
    <main-input v-model="form.website" :validator="$v.form.website"  :label="$tc('form.website')" />
    <main-input v-model="form.contact" :validator="$v.form.contact" :label="$tc('form.contact_person')" />
    <main-input v-model="form.mobile" :validator="$v.form.mobile" :label="$tc('form.mobile')" />
    <form-item :label="$tc('general.rank')">
      <span class="readonly-value">{{ clubRankDisplay }}</span>
    </form-item>
    <form-item :label="$tc('form.earned_points')">
      <span
        v-if="user.isAdmin"
        class="points-value points-value--clickable"
        @click="openPointsPopup">{{ clubPointsDisplay }}</span>
      <span v-else class="points-value">{{ clubPointsDisplay }}</span>
    </form-item>
    <main-upload-input v-model="logo" label="Logo"/>

    <club-points-history-modal
      v-model="showPointsPopup"
      :club="club"
      :can-add-points="user.isAdmin"
      @update="onClubPointsUpdated" />

    <template v-slot:footer>
      <div class="flex-buttons">
        <el-button @click="$emit('close')">Otkaži</el-button>
        <el-button type="primary" @click="save()">Izmeni</el-button>
      </div>
    </template>
  </main-drawer>
</template>

<script>
import errorHandler from '@/common/errorHandler.js'
import { required, email } from 'vuelidate/lib/validators'
import FormItem from '@/components/forms/FormItem.vue'
import ClubPointsHistoryModal from './ClubPointsHistoryModal.vue'

export default {
  components: {
    FormItem,
    ClubPointsHistoryModal
  },

  props: {
    club: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      form: {
        name: null,
        shortName: null,
        city: null,
        address: null,
        email: null,
        website: null,
        contact: null,
        mobile: null,
        earnedPoints: null
      },

      logo: null,
      showPointsPopup: false
    }
  },

  computed: {
    user () {
      return this.$store.state.auth.user
    },

    rankedClubs () {
      return this.$store.getters['ranking/clubs'] || []
    },

    clubRankDisplay () {
      if (!this.club?.id || !this.rankedClubs.length) return '—'
      const idx = this.rankedClubs.findIndex(c => c.id === this.club.id)
      return idx >= 0 ? String(idx + 1) : '—'
    },

    clubPointsDisplay () {
      if (!this.club?.id) return '0'
      const ranked = this.rankedClubs.find(c => c.id === this.club.id)
      if (ranked && ranked.points != null) return String(ranked.points)
      return this.form.earnedPoints != null ? String(this.form.earnedPoints) : '0'
    }
  },

  created () {
    this.$store.dispatch('ranking/loadClubs')
    this.form = {
      name: this.club.name,
      shortName: this.club.shortName,
      city: this.club.city,
      address: this.club.address,
      email: this.club.email,
      website: this.club.website,
      contact: this.club.contact,
      mobile: this.club.mobile,
      earnedPoints: this.club.earnedPoints
    }
  },

  methods: {
    async save () {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) return

      this.loading = true

      const payload = { ...this.form }
      delete payload.earnedPoints

      try {
        let club = await this.$store.dispatch('clubs/update', {
          id: this.club.id,
          payload
        })

        if (this.logo) {
          club = await this.$store.dispatch('clubs/upload', {
            id: club.id,
            file: this.logo
          })
        }

        this.$message.success('Uspešno ste izmenili udruženje.')
        this.$emit('edit', club)
      } catch (error) {
        errorHandler(error)
      } finally {
        this.loading = false
      }
    },

    openPointsPopup () {
      this.showPointsPopup = true
    },

    onClubPointsUpdated (updatedClub) {
      if (updatedClub) {
        this.form.earnedPoints = updatedClub.earnedPoints
        this.$emit('edit', updatedClub)
        this.$store.dispatch('ranking/loadClubs')
      }
    }
  },

  validations: {
    form: {
      name: { required },
      shortName: { required },
      city: { required },
      address: { required },
      email: { required, email },
      contact: { required },
      mobile: { required }
    }
  }
}
</script>

<style lang="scss" scoped>
.readonly-value,
.points-value {
  display: block;
  min-height: 32px;
  line-height: 32px;
  padding: 0 2px;
}

.points-value--clickable {
  cursor: pointer;
  text-decoration: underline;
  color: #409eff;
}
</style>
